export default "__VITE_ASSET__JtvQsymi__"